import { Dispatch, ReactNode, SetStateAction } from 'react';
import Modal from 'react-modal';

interface ModalComponentCameraType {
  children?: ReactNode;
  setModal: Dispatch<SetStateAction<boolean>>;
  modal: boolean;
  passport?: string;
}

const ModalComponentCamera = ({
  children,
  setModal,
  modal,
  passport
}: ModalComponentCameraType) => {
  return (
    <Modal
      isOpen={modal}
      onRequestClose={() => setModal(!modal)}
      contentLabel='My dialog'
      className={passport ? 'cameraModalPassport' : 'cameraModal'}
      overlayClassName='myoverlay'
      closeTimeoutMS={500}
      ariaHideApp={false}>
      {children}
    </Modal>
  );
};

export default ModalComponentCamera;
